import { useIntl } from "react-intl";
import { useStyle } from "./style";
import { ResizeHintIcon } from "@/common/icons/resizeHintIcon/resizeHintIcon";
import { ResizeHintProps } from "./types";
import { mergeClasses } from "@fluentui/react-components";

export const ResizeHint = (props: ResizeHintProps) => {
	const classes = useStyle();
	const intl = useIntl();

	return (
		<div className={classes.container}>
			<div
				className={mergeClasses(classes.resizeHint, props.className)}
				title={intl.formatMessage({ id: "Common.ResizeHintTitle" })}
			>
				<ResizeHintIcon />
			</div>
		</div>
	);
};
